import { createSlice } from '@reduxjs/toolkit';
import { addNewVehicleType, editVehicleType, editVehicleTypeImage, getAllVehicleTypes } from './vehicleTypesService';

const initialState = {
  allVehicleTypes: {
    isVehicleTypesLoading: null,
    isVehicleTypesSuccess: null,
    vehicleTypesMessage: null,
    pageCount: 0,
    vehicleTypes: [],
  },
  newVehicleType: {
    isVehicleTypeCreating: null,
    isVehicleTypeCreated: null,
    vehicleTypeCreationMsg: null,
  },

  editedVehicleType: {
    isEditingVehicleType: null,
    isVehicleTypeEdited: null,
    vehicleTypeEditedMsg: null
  },

  editedVehicleTypeImage: {
    isEditingVehicleTypeImage: null,
    isVehicleTypeImageEdited: null,
    vehicleTypeImageEditedMsg: null
  }
};

const vehicleTypesSlice = createSlice({
  name: 'vehicleType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllVehicleTypes.pending, (state) => {
        state.allVehicleTypes = {
          ...initialState.allVehicleTypes, // Reset to initial state
          isVehicleTypesLoading: true,
          vehicleTypesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllVehicleTypes.rejected, (state, action) => {
        state.allVehicleTypes = {
          ...initialState.allVehicleTypes,
          isVehicleTypesLoading: false,
          isVehicleTypesSuccess: false,
          vehicleTypesMessage: action.payload || 'Error occurred while fetching vehicleTypes',
        };
      })

      // FULFILLED
      .addCase(getAllVehicleTypes.fulfilled, (state, action) => {
        state.allVehicleTypes = {
          ...initialState.allVehicleTypes,
          isVehicleTypesLoading: false,
          isVehicleTypesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          vehicleTypes: action.payload.data || [],
        };
      });

    //VehicleType creating
    builder
      .addCase(addNewVehicleType.pending, (state) => {
        state.newVehicleType = {
          ...initialState.newVehicleType, // Reset to initial state
          isVehicleTypeCreating: true,
          vehicleTypeCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewVehicleType.rejected, (state, action) => {
        state.newVehicleType = {
          ...initialState.newVehicleType,
          isVehicleTypeCreating: false,
          isVehicleTypeCreated: false,
          vehicleTypeCreationMsg: action.payload || 'Error occurred while creating the vehicleType.',
        };
      })

      // FULFILLED
      .addCase(addNewVehicleType.fulfilled, (state, action) => {
        state.newVehicleType = {
          ...initialState.newVehicleType,
          isVehicleTypeCreating: false,
          isVehicleTypeCreated: true,
          vehicleTypeCreationMsg: action.payload || 'Successfully created the vehicleType.',
        };
      });

    //VehicleType editing
    builder
      .addCase(editVehicleType.pending, (state) => {
        state.editedVehicleType = {
          ...initialState.editedVehicleType, // Reset to initial state
          isEditingVehicleType: true,
          vehicleTypeEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editVehicleType.rejected, (state, action) => {
        state.editedVehicleType = {
          ...initialState.editedVehicleType, // Reset to initial state
          isEditingVehicleType: false,
          isVehicleTypeEdited: false,
          vehicleTypeEditedMsg: action.payload || 'Error occurred while editing the vehicleType.',
        };
      })

      // FULFILLED
      .addCase(editVehicleType.fulfilled, (state, action) => {
        state.editedVehicleType = {
          ...initialState.editedVehicleType, // Reset to initial state
          isEditingVehicleType: false,
          isVehicleTypeEdited: true,
          vehicleTypeEditedMsg: action.payload || 'Successfully edited the vehicleType.',
        };
      });

    //VehicleType image editing
    builder
      .addCase(editVehicleTypeImage.pending, (state) => {
        state.editedVehicleTypeImage = {
          ...initialState.editedVehicleTypeImage, // Reset to initial state
          isEditingVehicleTypeImage: true,
          vehicleTypeImageEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editVehicleTypeImage.rejected, (state, action) => {
        state.editedVehicleTypeImage = {
          ...initialState.editedVehicleTypeImage, // Reset to initial state
          isEditingVehicleTypeImage: false,
          isVehicleTypeImageEdited: false,
          vehicleTypeImageEditedMsg: action.payload || 'Error occurred while editing the vehicleType image.',
        };
      })

      // FULFILLED
      .addCase(editVehicleTypeImage.fulfilled, (state, action) => {
        state.editedVehicleTypeImage = {
          ...initialState.editedVehicleTypeImage, // Reset to initial state
          isEditingVehicleTypeImage: false,
          isVehicleTypeImageEdited: false,
          vehicleTypeImageEditedMsg: action.payload || 'Successfully edited the vehicleType image.',
        };
      });
  },
});

export default vehicleTypesSlice.reducer;
